import React, { useState, useEffect, useMemo } from 'react';

import { IPageFields } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';
import { useCookie } from '../../hooks/useCookie';

import { AffiliateHeader, getHeaderHeight } from '../AffiliateHeader';
import { Header } from '../Header';
import { Navbar } from '../Navbar';
import { TopSpacer } from '../TopSpacer';
import { VariationContainer } from '../VariationContainer';
import { Banners } from './Banners';
import { FixedHeader } from './styles';

export function Headers({ headerType, hideBanner, hideHeader }: IPageFields) {
  const {
    config: { header } = {},
    cookies: {
      gl_web_banner: webBanner,
      gl_is_registered_user: registeredUser
    } = {}
  } = usePageDataContext();

  // Default banner display status from server cookie and page prop
  const [bannerVisible, updateBanner] = useState(
    webBanner === 'show' && registeredUser !== 'true' && !hideBanner
  );

  // Use client cookie to manage for banner status
  const [wbCookie, updateCookie] = useCookie('gl_web_banner');
  const [ruCookie] = useCookie('gl_is_registered_user');

  useEffect(() => {
    // Update banner when cookie changes
    updateBanner(wbCookie === 'show' && ruCookie !== 'true' && !hideBanner);
  }, [wbCookie, ruCookie]);

  // If page query returns 'headerType' data, show either regular Header... or Affiliate Header.
  // If page query returns 'contentfulGlobalConfig' data, show either: regular Header... or Variation Container
  const { sys, fields }: any = headerType ?? header ?? {};

  const contentType = sys?.contentType?.sys?.id;
  const isAffiliate = contentType === 'affiliateHeader';

  const { headerHeight } = useMemo(
    () => getHeaderHeight(fields?.affiliateLogo),
    [isAffiliate]
  );

  return (
    <>
      {(!hideHeader || !hideBanner) && (
        <FixedHeader isAffiliate={isAffiliate}>
          {/* Don't show webBanner on affiliate pages */}
          {bannerVisible && !isAffiliate && (
            <Banners toggleBanner={updateCookie} />
          )}

          {!hideHeader &&
            (() => {
              switch (contentType) {
                case 'affiliateHeader':
                  return <AffiliateHeader {...fields} />;

                case 'header':
                  return <Header {...fields} />;

                case 'header2':
                  return <Navbar {...fields} />;

                case 'variationContainer':
                  return <VariationContainer {...fields} sysId={sys?.id} />;

                default:
                  return null;
              }
            })()}
        </FixedHeader>
      )}

      <TopSpacer heights={{ 0: headerHeight }} bannerVisible={bannerVisible} />
    </>
  );
}
